import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeletePlaybookMutation} from '../hooks/usePlaybooksQuery';
import {usePlaybooksSelection} from "../hooks/usePlaybooksSelection.ts";


export const DeleteRecordButton = () => {

    const deletePlaybookMutation = useDeletePlaybookMutation();

    const {
        selection,
        handleClearSelection,
    } = usePlaybooksSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deletePlaybookMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
